import { RouteObject } from "react-router-dom"
import AuthGuard from "../../../shared/auth/component/auth"
import UserPage from "../page/owner.page"
import OwnerPage from "../page/owner.page"
import NewOwnerComponent from "../component/new-owner-component"
export const OwnerRoute: RouteObject = {
  path: "/owner",
  element: (
    <AuthGuard role={["super_admin", "admin"]} permission={["manage-owners", "view-owners"]}>
      <OwnerPage />
    </AuthGuard>
  ),
  children: [
    {
      path: "detail/:type/:id",
      element: <NewOwnerComponent editMode="detail" />,
    },
    { path: ":id", element: <NewOwnerComponent editMode="new" /> },
  ],
}
